import createClient from "openapi-fetch"
import type { paths } from "../generated/types"
import { customFetch } from "./fetch"

export const client = createClient<paths>({
  baseUrl:
    process.env.NEXT_PUBLIC_API_URL || "http://localhost:8001/api",
  fetch: customFetch
})